// const debug = "CustomFields Proxy"
const debug = false

export default {
    set: (object:any, key:string, value:any, proxy:any) => {

        debug && console.log(debug, "set key=", key, "value=", value)

        // mark item as updated
        object._lastUpdatedTime = Date.now()

        if (Reflect.has(object, key)) {
            // Updating existing field
            object[key] = value;
            object.updatedFields?.add(key);
        } else {
            // normalize customFieldsData
            if (!object.customFieldsData) object.customFieldsData = {};

            // remove customFieldsData property if value is null, undefined or empty string
            if (_.isNil(value) ||
                (typeof value === 'string' && value.trim() === ''))
                delete object.customFieldsData[key]; // remove customFieldsData property if set to null
            else
                object.customFieldsData[key] = value;

            // mark customFieldsData as updated
            object.updatedFields?.add('customFieldsData');

            // experimental Vic may 4 2024 - support for task save
            object.updatedFields?.add('cf-'+key);
        }
        return true;
    },

    get: (object:any, key:any, proxy:any) => {
        debug && console.log(debug, "get key=", key)

        if (Reflect.has(object, key)) {
            return object[key]
        } else {

            // special case
            // A String value that is used in the creation of the default string description of an object. Called by the built-in method Object.prototype.toString.
            if (key === Symbol.toStringTag || ['@@toStringTag'].includes(key))
                return object.constructor.name;

            // console.log("access dynamic key (customField) key=", key)

            return _.get(object, 'customFieldsData.{0}'.f(key), undefined);
        }
    }
}
